import React from "react";
import { RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";
import { DateTime } from "luxon";

import { V2 } from "../../../Api";
import { formatDateLocalNumeric, formatName } from "../../../Utilities";
import ViewToolbar from "../../ViewToolbar";
import ToolbarMenuItem from "../../ToolbarMenuItem";
import { surgeryStatusToText } from "../../../TextTables";

import "../../../patient.css";
import "../../../list.css";


interface IPatientSurgeryListViewProps extends RouteComponentProps<any> {

}

interface IPatientSurgeryListViewState {
    isLoading: boolean | string;
    surgeries: any[];
}

class PatientSurgeryListView extends React.Component<IPatientSurgeryListViewProps, IPatientSurgeryListViewState> {
    constructor(props: Readonly<IPatientSurgeryListViewProps>) {
        super(props);

        const state: IPatientSurgeryListViewState = {
            isLoading: false,
            surgeries: []
        };

        this.state = state;
    }

    public componentDidMount() {
        this.loadData();
    }

    public render() {
        if (this.state.isLoading === true) {
            return <div className="patient-page-body">
                <div className="spinner spinner-center lds-dual-ring" />
            </div>;
        }
        if (typeof this.state.isLoading === "string") {
            return <div className="patient-page-body">
                <div className="error-text">{this.state.isLoading}</div>
            </div>;
        }

        const now = DateTime.local().startOf("day");

        return (
            <div className="patient-page-body">
                <ViewToolbar>
                    <ToolbarMenuItem>
                        <Link to={{ pathname: `/surgery/create`, state: { patientId: this.props.match.params.id } }} className="icon-plus" title="Create surgery..." />
                    </ToolbarMenuItem>
                </ViewToolbar>
                <table className="table-vertical">
                    <thead>
                        <tr>
                            <th className="col-smallest"></th>
                            <th className="col-smallest">Date</th>
                            <th>Operation</th>
                            <th>Surgeon</th>
                            <th className="col-smallest">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.surgeries.length === 0
                            ? <tr>
                                <td colSpan={10}>No surgeries found for this patient</td>
                            </tr>
                            : this.state.surgeries.map(a => <tr key={a.id} className="clickable" onClick={() => this.goSurgery(a.id)}>
                                <td>{DateTime.fromISO(a.date).startOf("day") > now ? <i className="icon-clock-o" title="Upcoming appointment" /> : null}</td>
                                <td>{formatDateLocalNumeric(a.date)}</td>
                                <td>{a.primarySurgery.shortName || a.primarySurgery.name}</td>
                                <td>{formatName(a.primarySurgeon.name)}</td>
                                <td>{surgeryStatusToText(a.status)}</td>
                            </tr>)}
                    </tbody>
                </table>
            </div>
        );
    }

    private async loadData() {
        try {
            this.setState({
                isLoading: true
            });

            const result = await V2.get<any>(`patients/${this.props.match.params.id}/surgeries`);

            this.setState({
                isLoading: false,
                surgeries: result.surgeries,
            });
        }
        catch (e) {
            this.setState({
                isLoading: e.message || "Could not load documents"
            });
        }
    }

    private goSurgery(id: string) {
        this.props.history.push(`/surgery/${id}`);
    }
}

export default PatientSurgeryListView;
